import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import LoadScript from "vue-plugin-load-script";
// cookie test
import VueCookieAcceptDecline from 'vue-cookie-accept-decline';
// import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css';
import VueCookies from 'vue-cookies'

createApp(App).use(i18n).use(store).use(router).use(LoadScript).use(VueCookies, { expires: -1}).component('vue-cookie-accept-decline', VueCookieAcceptDecline).mount("#app");

